import type { Activity } from "@lib/activity";
import { useCookies } from "react-cookie";
import { loadGTMPixel, setInitialDataLayerVariables } from "./gtm-pixel";
import { useEffect } from "react";

type GTMProps = {
  activity: Activity;
  code: string;
};

export function GTM({ activity, code }: GTMProps) {
  const [cookies] = useCookies([`sopost-purpose_${activity.id}`]);
  const cookie = cookies[`sopost-purpose_${activity.id}`] as string | undefined;

  useEffect(() => {
    if (!cookie || cookie === "rejected") return;
    const analyticalConsentGiven = cookie?.includes("analytical") || false;
    const marketingConsentGiven = cookie?.includes("marketing") || false;

    loadGTMPixel(code);
    setInitialDataLayerVariables({
      activity,
      analyticalConsentGiven,
      marketingConsentGiven,
    });
  }, [code, cookie]);

  return <></>;
}
